export default "__VITE_ASSET__Dwt67uP$__"